// Firebase Realtime Database 다운로드 용량 추적
let totalBytes = 0
let totalCount = 0

const isDev = import.meta.env.VITE_BUILD_MODE?.includes('dev')

export const trackFirebaseDownload = (source: string, val: unknown): void => {
  if (!isDev) return
  const size = new Blob([JSON.stringify(val)]).size
  totalBytes += size
  totalCount++
  const kb = (totalBytes / 1024).toFixed(1)
  const mb = (totalBytes / 1024 / 1024).toFixed(2)
  console.info(`[Firebase 📥] ${source} #${totalCount} +${size}B | 누적: ${kb}KB (${mb}MB)`)
}

export const getFirebaseDownloadStats = (): { totalBytes: number; totalCount: number } => {
  return { totalBytes, totalCount }
}
